import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useTenantFeatures } from "@/context/TenantFeaturesContext";
import type { TenantFeatureKey } from "@/types/tenantFeatures";

type FeatureRouteProps = {
  feature: TenantFeatureKey;
  children: ReactNode;
};

/** Redirects home if this tenant feature is off (see GET /tenant/features). */
export function FeatureRoute({ feature, children }: FeatureRouteProps) {
  const { loading, isFeatureEnabled } = useTenantFeatures();

  if (loading) {
    return null;
  }

  if (!isFeatureEnabled(feature)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
